import React from 'react';
import { StyleSheet } from 'react-native';

import { Color, CommonProperties } from '../styles';
import BaseText from './BaseText';

const TitleForm = (props) => {
  return <BaseText style={styles.title}>{props.title}</BaseText>;
};

const styles = StyleSheet.create({
  title: {
    flex: 1,
    color: Color.text.high,
    textAlign: 'center',
    ...CommonProperties.h4,
    ...CommonProperties.py3,
  },
});

export default TitleForm;
